import { useState } from "react";
import { useNavigate } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;
export default function ResearchQuestions() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [answers, setAnswers] = useState({
    research_interests: "",
    has_active_project: null,
    research_type: ""
  });

  const handleChange = (key, value) => {
    setAnswers(prev => ({
      ...prev,
      [key]: value
    }));
  };

 const handleSubmit = async () => {
  try {
    setLoading(true);
    const response = await fetch(
      `${BASE_URL}/marketplace/researcher/create-researcher-profile/`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
        body: JSON.stringify({ answers: answers })
      }
    );

    const responseData = await response.json();

    if (response.ok) {
      alert('Your Researcher Profile Created Successfully');

      const statusResponse = await fetch(`${BASE_URL}/marketplace/researcher/payment-status/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      });

      const statusData = await statusResponse.json();

      if (!statusResponse.ok || statusData?.paid === false) {
        navigate("/marketplace/independent_researcher/payment");
      } else {
        navigate("/marketplace/independent_researcher/dashboard");
      }
    } else {
      console.error("Failed to create profile", responseData);
      alert(responseData?.message || "Failed to create profile. Please try again.");
    }
  } catch (error) {
    console.error("Error creating profile:", error);
    alert("Error creating profile. Please try again.");
  } finally {
    setLoading(false);
  }
};

  return (
      <>
<div className="w-full max-w-[97%] mx-auto p-8 space-y-8 bg-white rounded-2xl border border-gray-200">
  {/* Header */}
  <div className="flex items-center gap-3 mb-6">
    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
      <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
      </svg>
    </div>
    <div>
      <h3 className="text-lg font-semibold text-gray-900">Research Preferences</h3>
      <p className="text-sm text-gray-500">Tell us about your research focus</p>
    </div>
  </div>

  {/* Question 1 */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        What are your current research interests?
      </label>
    </div>
    <input
      type="text"
      placeholder="e.g., Artificial Intelligence, Climate Change, Quantum Computing"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      value={answers.research_interests}
      onChange={(e) => handleChange("research_interests", e.target.value)}
    />
    <p className="text-xs text-gray-500 mt-2">Separate multiple interests with commas</p>
  </div>

  {/* Question 2 */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <p className="text-sm font-semibold text-gray-700">
        Are you currently working on any active research projects?
      </p>
    </div>
    <div className="flex gap-6">
      <label className="flex items-center gap-3 cursor-pointer group">
        <div className="relative">
          <input
            type="radio"
            name="active_project"
            checked={answers.has_active_project === true}
            onChange={() => handleChange("has_active_project", true)}
            className="sr-only"
          />
          <div className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${answers.has_active_project === true ? 'border-[#0f6abf]' : 'border-gray-300'}`}>
            {answers.has_active_project === true && (
              <div className="w-2.5 h-2.5 bg-[#0f6abf] rounded-full"></div>
            )}
          </div>
        </div>
        <span className="text-gray-700">Yes</span>
      </label>
      <label className="flex items-center gap-3 cursor-pointer group">
        <div className="relative">
          <input
            type="radio"
            name="active_project"
            checked={answers.has_active_project === false}
            onChange={() => handleChange("has_active_project", false)}
            className="sr-only"
          />
          <div className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${answers.has_active_project === false ? 'border-[#0f6abf]' : 'border-gray-300'}`}>
            {answers.has_active_project === false && (
              <div className="w-2.5 h-2.5 bg-[#0f6abf] rounded-full"></div>
            )}
          </div>
        </div>
        <span className="text-gray-700">No</span>
      </label>
    </div>
  </div>

  {/* Question 3 */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <p className="text-sm font-semibold text-gray-700">
        What type of research do you mainly conduct?
      </p>
    </div>
    <div className="grid grid-cols-2 gap-3">
      {["Theoretical", "Applied", "Experimental", "Interdisciplinary"].map(
        (type) => (
          <label key={type} className={`flex items-center gap-3 cursor-pointer p-3 rounded-xl transition-colors ${answers.research_type === type.toLowerCase() ? 'bg-[#e8f0f7] border border-[#0f6abf]' : 'bg-gray-50 hover:bg-gray-100'}`}>
            <div className="relative">
              <input
                type="radio"
                name="research_type"
                checked={answers.research_type === type.toLowerCase()}
                onChange={() => handleChange("research_type", type.toLowerCase())}
                className="sr-only"
              />
              <div className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${answers.research_type === type.toLowerCase() ? 'border-[#0f6abf]' : 'border-gray-300'}`}>
                {answers.research_type === type.toLowerCase() && (
                  <div className="w-2.5 h-2.5 bg-[#0f6abf] rounded-full"></div>
                )}
              </div>
            </div>
            <span className="text-gray-900">{type}</span>
          </label>
        )
      )}
    </div>
  </div>

  {/* Submit Button */}
  <div className="pt-6 border-t border-gray-200">
    <button
      onClick={handleSubmit}
      disabled={loading}
      className="w-full py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
    >
      {loading ? (
        <>
          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          Saving...
        </>
      ) : (
        "Save Research Preferences"
      )}
    </button>
  </div>
</div>
   
</>
  );
}
